<template>
  <main class="main" role="main">
    <div class="main__inner"><!-- 배경: bg-->
      <div class="main__con">
        <div class="main__con__ttl" v-if="isLoad">
          <div class="box__con__route_name type_02"> <!--세로정렬-->
            <span class="academy">컨설팅 진행현황</span>
            <span class="route">{{ userData.companyName }}</span>
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status status__number on">진행 절차</span>
            </div>
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status__work">1</span>
              <div class="line"></div>
              <span class="status status__number">컨설팅 진행 (구두 협의)</span>
<!--              <span class="status status__number" :class="{'on': $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 1}">컨설팅 진행 (구두 협의)</span>-->
            </div>
<!--            <button class="btn_call" v-if="$ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 1">진행중</button>-->
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status__work">2</span>
              <div class="line"></div>
              <span class="status status__number">서류 안내 및 현장 조사</span>
<!--              <span class="status status__number" :class="{'on': $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 2}">서류 안내 및 현장 조사</span>-->
            </div>
<!--            <button class="btn_call" v-if="$ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 2">진행중</button>-->
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status__work">3</span>
              <div class="line"></div>
              <span class="status status__number">서류 제출</span>
<!--              <span class="status status__number" :class="{'on': $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 3}">서류 제출</span>-->
            </div>
<!--            <button class="btn_call" v-if="$ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 3">진행중</button>-->
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status__work">4</span>
              <div class="line"></div>
              <span class="status status__number">한전 실사 및 공사</span>
<!--              <span class="status status__number" :class="{'on': $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 4}">한전 실사 및 공사</span>-->
            </div>
<!--            <button class="btn_call" v-if="$ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 4">진행중</button>-->
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status__work">5</span>
              <div class="line"></div>
              <span class="status status__number">한전 승인</span>
<!--              <span class="status status__number" :class="{'on': $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 5}">한전 승인</span>-->
            </div>
<!--            <button class="btn_call" v-if="$ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 5">진행중</button>-->
          </div>
          <div class="box__con__flex_box">
            <div class="box__con__status">
              <span class="status__work">6</span>
              <div class="line"></div>
              <span class="status status__number">절감 보고 및 사후 관리</span>
<!--              <span class="status status__number" :class="{'on': $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 6}">절감 보고 및 사후 관리</span>-->
            </div>
<!--            <button class="btn_call" v-if="$ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType][electData.progressStatus].status === 6">진행중</button>-->
          </div>
        </div>
        <div class="small_notice">
          <div class="txt" style="margin: 0 auto;">
            <p><span style="font-size: 1.4rem;">세부 진행 현황</span></p>
          </div>
<!--          <button class="btn">진행중</button>-->
        </div>
        <div class="bus_route" id="statusWrap">
          <div class="progress" v-for="(item, index) in $ConstCode.CODE_SERVICE_PROGRESS_STATUS[electData.progressType]" :key="index">
            <div class="status">
              <div class="status__marker" :class="{'on' : electData.progressStatus === item.value}" :id="`status_${item.value}`"></div>
            </div>
            <div class="route">{{ item.label }}</div>
          </div>
        </div>
      </div>
      <div class="small_notice inquire">
        <p class="complete__txt__small" style="margin-top: 0; margin: 0 auto;">
          문의사항은 문의하기를 이용해주세요.
        </p>
      </div>
    </div>
  </main>
</template>
<script>
export default {
  data: function () {
    return {
      isLoad: false,
      electData: {}
    }
  },
  created: async function () {
    await this.getSerivceStatus();
  },
  computed: {
    userData: function () {
      return this.$store.getters['account/getUserData']
    }
  },
  methods: {
    getSerivceStatus: async function () {
      const params = {userNo: this.userData.userNo}
      const res = await this.$MainSvc.getServiceStatus(params)
      const code = res.code
      const message = res.message
      const entity = res.entity

      // console.log('code: %d\nmessage: %s\nentity: %o\nstringify: \n%s', code, message, entity, JSON.stringify(entity))

      if (code === 1) {
        this.isLoad = true
        this.electData = entity.electData

        this.$nextTick(() => {
          let elID = `status_${this.electData.progressStatus}`
          this.$Util.scrollToStatus(elID)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main__con {
  position : relative;

  .box__con__route_name.type_02 {
    text-align: center;
    margin-bottom: 1.5rem;
  }

  .box__con__status {
    margin-top: 0.5rem;
    .status__work {
      border: 1px solid #9E9E9E;
      margin-right: 0.8rem;
      color: #9E9E9E;
      font-weight: 500;
      width: 2.4rem;
      height: 2.4rem;
      border-radius: 1.2rem;
      text-align: center;
      line-height: 2.2rem;
      font-size: 1.2rem;
    }

    .status__number {
      font-size: 1.4rem;
    }

    .status__number.on {
      color: black;
      padding-left: 0;
    }
  }

  .btn_call {
    padding: 0.3rem 0.8rem;
    border: 1px solid red;
    border-radius: 5rem;
    width: auto;
    background: #FFFFFF;
    font-size: 1.2rem;
    font-weight: 500;
    color: red;
  }

  .bus_route {
    display: flex;
    white-space: nowrap;
    overflow-x: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
    &::-webkit-scrollbar {
      display: none;
    }

    padding: 5rem 10rem;

    .progress {
      display: inline-block;
      min-width: 17rem;

      &:not(:first-child):not(:last-child) {
        border-top: 1px #BDBDBD solid;
      }

      .status {
        position: relative;
        height: 1px;
      }

      &:first-child .status:after {
        content: "";
        display: block;
        width: 8.5rem;
        border-top: 1px #BDBDBD solid;
        margin-left: 8.5rem;
      }

      &:last-child .status:after {
        content: "";
        display: block;
        width: 8.5rem;
        border-top: 1px #BDBDBD solid;
      }

      .status__marker {
        position: absolute;
        top: -1.5rem;
        left: 7rem;
        padding: 1.5rem;
        background: url(../../assets/static/images/i_round.svg) no-repeat center;
      }

      .status__marker.on {
        background: url(../../assets/static/images/i_check.svg) no-repeat center;
      }

      .route {
        padding: 2rem 2.2rem;
        text-align: center;
        font-size: 1.4rem;
      }
    }
  }

  .small_notice.inquire {
    position: absolute;
    width: 100%;
    bottom: 0;
  }
}
</style>
